module.exports = __webpack_public_path__ + "static/the-power-of-now-9dce79230afb8b48e75a19be4433d7f9.jpg";